import React, { useEffect, useRef, useState } from 'react'
import Pagination from '../pagination/pagination';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { glossaryListAction, translationMemoryDeleteAction, translationMemoryEnableDisableAction, translationMemoryExportAction, translationMemoryListAction } from '../../redux/actions/resourceAction';
import CustomCheckboxDropdown from '../forms/checkBoxDropDown';
import CustomButton from '../button/button';
import { GrMoreVertical } from 'react-icons/gr';
import errorToast from '../toasts/errorToast';
import successToast from '../toasts/successToast';
import { getLangName } from '../helper';
import moment from 'moment';
import { availableLanguages } from '../data/languageData';
import { useAuth } from '../../context/AuthContext';

const TranslationMemory = () => {
    const userDetails = useSelector((store) => store?.userReducer?.data);

    const [tmFilteredData, setTmFilteredData] = useState([]);
    const [tmName, setTmName] = useState("");
    const [tmStartDate, setTmStartDate] = useState("")
    const [tmEndDate, setTmEndDate] = useState("");
    const [tmLangFilter, setTmLangFilter] = useState([]);
    const [tmFiltersApplied, setTmFiltersApplied] = useState(false);
    const [tmLoading, setTmLoading] = useState(true);
    const [tmPage, setTmPage] = useState(1);
    const [tmRowsPerPage, setTmRowsPerPage] = useState(10);
    const [tmPaginationData, setTmPaginationData] = useState({});
    const [tmShowOptions, setTmShowOptions] = useState(false);
    const [tmShowClearIndex, setTmShowClearIndex] = useState(null);
    const [tmExportLoading, setTmExportLoading] = useState(false);

    const [checked, setChecked] = useState(false);
    const dropdownRef = useRef(null);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { isAdmin } = useAuth();

    useEffect(() => {
        setChecked(userDetails?.company?.is_translationMemory)
        setTmLoading(false)
    }, [userDetails])

    const handleTmApplyFilters = () => {
        setTmLoading(true);
        setTmFiltersApplied(true); // Show the table after filters are applied
    };

    // Function to fetch all records without filters
    const handleGetAllTmRecords = () => {
        setTmLoading(true);
        setTmName('');
        setTmLangFilter([]);
        setTmStartDate('');
        setTmEndDate('');
        setTmFiltersApplied(true); // Show the table
        dispatch(translationMemoryListAction({ tmPage, page_size: tmRowsPerPage, is_okapi: true }, onTmlistSuccess, onError)); // No filters
    };

    const handleTmClear = () => {
        setTmLoading(false);
        setTmName('');
        setTmLangFilter([]);
        setTmStartDate('');
        setTmEndDate('');
        setTmFiltersApplied(false);
    };

    useEffect(() => {
        if (tmFiltersApplied) {
            setTmLoading(true);
            dispatch(
                translationMemoryListAction(
                    {
                        page: tmPage,
                        page_size: tmRowsPerPage,
                        name: tmName,
                        lang: tmLangFilter,
                        from_date: tmStartDate,
                        to_date: tmEndDate,
                        is_okapi: true
                    },
                    onTmlistSuccess,
                    onError
                )
            );
        }
    }, [tmPage, tmRowsPerPage, tmName, tmLangFilter, tmStartDate, tmEndDate, tmFiltersApplied, dispatch]);

    const onTmlistSuccess = (data) => {
        setTmPaginationData(data?.data?.data?.pagination);
        setTmFilteredData(data?.data?.data?.translationMemories);
        setTmLoading(false);
    };

    const onError = (data) => {
        errorToast(data?.data?.message);
    };

    const handleTmMoreOptionsClick = (item, index) => {
        setTmShowClearIndex(index);
        setTmShowOptions(!tmShowOptions);
    };

    const handleTmDeleteClick = (id) => {
        setTmLoading(true);
        dispatch(translationMemoryDeleteAction({ id }, onTmDeleteSuccess, onError));
    };

    const handleToggle = () => {
        setTmLoading(true);
        dispatch(translationMemoryEnableDisableAction({}, onToggleSuccess, onError));
    };

    const onToggleSuccess = (data) => {
        successToast(data?.data?.message);
        setChecked(!checked);
    };

    const onTmDeleteSuccess = (data) => {
        if (tmFiltersApplied) {
            setTmLoading(true);
            dispatch(
                translationMemoryListAction(
                    {
                        page: tmPage,
                        page_size: tmRowsPerPage,
                        name: tmName,
                        lang: tmLangFilter,
                        from_date: tmStartDate,
                        to_date: tmEndDate,
                        is_okapi: true
                    },
                    onTmlistSuccess,
                    onError
                )
            );
        }
        setTmShowOptions(false);
        setTmShowClearIndex(null);
        successToast(data?.data?.message);
    };


    const [tmDropdownOpen, setTmDropdownOpen] = useState(false);
    const checkboxTmDropdownRef = useRef(null);

    const downloadFile = (fileUrl) => {
        const link = document.createElement('a');
        link.href = fileUrl;

        // Optional: Extract filename from URL
        const fileName = fileUrl.split('/').pop();
        link.download = fileName;

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }

    const onExportSuccess = (data) => {
        downloadXml(data?.data?.data);
        successToast(data?.data?.message);
        setTmExportLoading(false);
        setTmShowClearIndex(null);
    };

    const handleTmExportClick = (id) => {
        setTmExportLoading(true);
        dispatch(translationMemoryExportAction({ id }, onExportSuccess, onError));
    };

    const downloadXml = (xmlString, fileName = "file.xml") => {
        const blob = new Blob([xmlString], {
            type: "application/xml;charset=utf-8",
        });

        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");

        a.href = url;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();

        document.body.removeChild(a);
        URL.revokeObjectURL(url);
    };


    return (
        <div>
            <section id="translation-memories" className="mt-5">
                <div className="d-flex justify-content-start align-items-center mt-4 w-fit">
                    <h5
                        className="text-start mt-1 mx-3 fs_20 fw_400 fn_Roboto text-nowrap    "
                    >
                        Translation Memories
                    </h5>


                    {userDetails?.user_type === "admin" &&
                        <div className="d-flex justify-content-between align-items-center w-100 mx-3">

                            <div className="d-flex align-items-center gap-2">
                                <div
                                    className={`custom-toggle ${checked ? "on" : "off"}`}
                                    onClick={handleToggle}
                                    role="button"
                                    aria-pressed={checked}
                                >
                                    <div className="toggle-knob" />
                                </div>
                                <span className="fw-bold">{checked ? "ON" : "OFF"}</span>
                            </div>

                            {/* <CustomButton
                                variant="primary"
                                onClick={handleGetAllTmRecords}
                            >
                                Add Translation Memory  
                            </CustomButton> */}

                        </div>


                    }
                </div>

                <p className="text-start mx-3 mt-2">Translation memories store human-reviewed sentence pairs. Users can apply a translation memory on their translations and any matching source sentences are replaced by the human-reviewed translations.</p>
                <div className='d-flex flex-wrap gap-3 px-3 pb-3'>

                    <div className="text-start text-nowrap" ref={checkboxTmDropdownRef} style={{ maxWidth: '14rem' }}>
                        <label htmlFor={`target_langugaes`} className="">Language</label>
                        <div className="custom-dropdown">
                            <CustomCheckboxDropdown
                                key="tmemories"
                                options={availableLanguages}
                                name={"tm_languages"}
                                value={tmLangFilter}
                                onChange={(field, value) => setTmLangFilter(value)}
                                placeholder={'Select Languages'}
                                dropdownOpen={tmDropdownOpen}
                                setDropdownOpen={setTmDropdownOpen}
                                width="14rem"
                                disabled={!checked}
                            />
                        </div>
                    </div>

                    <div className='text-start'>
                        <span className="">From Date</span>
                        <div className='' style={{ width: '14rem' }}>
                            <input
                                type='date'
                                name='startDate'
                                className='input-field w-100'
                                value={tmStartDate}
                                onChange={(e) => setTmStartDate(e.target.value)}
                                max={new Date().toISOString().split('T')[0]}
                                disabled={!checked}
                            />
                        </div>
                    </div>

                    <div className='text-start'>
                        <span className="">To Date</span>
                        <div className='' style={{ width: '14rem' }}>
                            <input
                                type='date'
                                name='endDate'
                                className='input-field w-100'
                                value={tmEndDate}
                                onChange={(e) => setTmEndDate(e.target.value)}
                                max={new Date().toISOString().split('T')[0]}
                                disabled={!checked}
                            />
                        </div>
                    </div>
                </div>

                <div className="d-flex flex-wrap justify-content-start gap-3 mx-3 text-nowrap">
                    <CustomButton variant="primary" onClick={handleTmApplyFilters} disabled={!tmName && !tmStartDate && !tmEndDate && tmLangFilter.length === 0} >
                        Apply Filters
                    </CustomButton>
                    <CustomButton variant="primary" onClick={handleGetAllTmRecords} disabled={!checked} >
                        Show All
                    </CustomButton>
                    <CustomButton variant="secondary" onClick={handleTmClear} disabled={!checked}>
                        Clear Filters
                    </CustomButton>
                </div>

                {tmFiltersApplied && (
                    <>
                        <div className="m-3 overflow-auto">
                            <div
                                className="table-responsive"
                                style={{ minHeight: "26rem", minWidth: "100%" }}
                            >
                                <table className="table table-bordered">
                                    <thead className="table-light">
                                        <tr className="text-start text-nowrap">
                                            <th width={"5%"} className="fw_400">
                                                Sl No.
                                            </th>
                                            <th width={"30%"} className="fw_400">
                                                Resource Name
                                            </th>
                                            <th width={"35%"} className="fw_400">
                                                Language Set
                                            </th>
                                            <th width={"15%"} className="fw_400">
                                                Create Date
                                            </th>
                                            <th width={"15%"} className="fw_400">
                                                Last Updated
                                            </th>
                                            {isAdmin && <th></th>}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {tmLoading ? (
                                            <tr>
                                                <td colSpan="7">loading...</td>
                                            </tr>
                                        ) : tmFilteredData?.length > 0 ? (
                                            tmFilteredData?.map((item, index) => (
                                                <tr key={index} className="text-start">
                                                    <td>{index + 1}</td>
                                                    <td>{item.file_name}</td>
                                                    <td>
                                                        {getLangName(item?.source_lang) + " → " + getLangName(item?.target_lang)}
                                                    </td>
                                                    <td>
                                                        {moment(item?.createdAt).format("MM/DD/YY, hh:mm A")}
                                                    </td>
                                                    <td>
                                                        {moment(item?.updatedAt).format("MM/DD/YY, hh:mm A")}
                                                    </td>
                                                    {isAdmin && (
                                                        <td>
                                                            <GrMoreVertical
                                                                className="cursor_pointer"
                                                                onClick={() => handleTmMoreOptionsClick(item, index)}
                                                            />
                                                            {tmShowOptions && tmShowClearIndex === index && (
                                                                <div
                                                                    className="position-relative"
                                                                    ref={dropdownRef}
                                                                >
                                                                    <div
                                                                        className="position-absolute"
                                                                        style={{ left: tmExportLoading ? "-7rem" :"-5rem" }}
                                                                    >
                                                                        <div className="card" style={{ width: tmExportLoading ? "7rem" : "5rem" }}>
                                                                            <div className="card-body p-2">
                                                                                <label
                                                                                    className="d-block text-danger cursor_pointer hover-effect"
                                                                                    onClick={() => {
                                                                                        handleTmDeleteClick(item.id);
                                                                                    }}
                                                                                >
                                                                                    Delete
                                                                                </label>
                                                                                <label
                                                                                    className="d-block cursor_pointer hover-effect"
                                                                                    onClick={() => {
                                                                                        handleTmExportClick(item.id);
                                                                                    }}
                                                                                >
                                                                                    { tmExportLoading ? "Exporting..." : "Export"}
                                                                                </label>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            )}
                                                        </td>
                                                    )}
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan="7">No rows to display</td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div className="mx-4 pb-3 d-flex justify-content-end">
                            {!tmLoading &&
                                <Pagination
                                    data={tmPaginationData}
                                    nextFunc={() => setTmPage(tmPage + 1)}
                                    prevFunc={() => setTmPage(tmPage - 1)}
                                    setPageRowFunc={(value) => {
                                        setTmPage(1);
                                        setTmRowsPerPage(value);
                                    }}
                                />
                            }
                        </div>
                    </>
                )}
            </section>
        </div>
    )
}

export default TranslationMemory